module.exports = __webpack_public_path__ + "88891262974af4cc827489ea4475d8b2.woff2";